const textureImagesProd = [
    {
        name: 'Beaches2.jpg',
        path: 'pxl-kjmdkwkh/Beaches2.jpg',
        file_size: 707773,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/Beaches2.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/Beaches2.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-13T07:26:31.020657Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'EFMwcNVevI',
        saved_images: {},
        width: 1000,
        height: 667,
    },
    {
        name: 'texture7.jpg',
        path: 'pxl-kjmdkwkh/texture7.jpg',
        file_size: 945949,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture7.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture7.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T10:20:34.881442Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'vMsiLmxzCO',
        saved_images: {},
        width: 1000,
        height: 702,
    },
    {
        name: 'texture15.jpg',
        path: 'pxl-kjmdkwkh/texture15.jpg',
        file_size: 119922,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture15.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture15.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T10:20:35.751906Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'ekOPaiTtDS',
        saved_images: {},
        width: 1000,
        height: 667,
    },
    {
        name: 'texture10.jpg',
        path: 'pxl-kjmdkwkh/texture10.jpg',
        file_size: 932039,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture10.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture10.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T10:20:38.915238Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'uVOsxKEvnG',
        saved_images: {},
        width: 1000,
        height: 563,
    },
    {
        name: 'texture11.jpg',
        path: 'pxl-kjmdkwkh/texture11.jpg',
        file_size: 498035,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture11.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture11.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T10:20:38.897338Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'sguuCRqwaY',
        saved_images: {},
        width: 1000,
        height: 600,
    },
    {
        name: 'texture8.jpg',
        path: 'pxl-kjmdkwkh/texture8.jpg',
        file_size: 892738,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture8.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture8.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T10:20:42.437906Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'McQUAiBJnY',
        saved_images: {},
        width: 1000,
        height: 471,
    },
    {
        name: 'texture9.jpg',
        path: 'pxl-kjmdkwkh/texture9.jpg',
        file_size: 1303693,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture9.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture9.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T10:20:42.382673Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'vmkwuXfypO',
        saved_images: {},
        width: 1000,
        height: 668,
    },
    {
        name: 'texture4.jpg',
        path: 'pxl-kjmdkwkh/texture4.jpg',
        file_size: 273702,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture4.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture4.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T10:20:43.263187Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'JUjjLQoMDJ',
        saved_images: {},
        width: 1000,
        height: 667,
    },
    {
        name: 'texture12.jpg',
        path: 'pxl-kjmdkwkh/texture12.jpg',
        file_size: 289278,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture12.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture12.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T10:20:43.456687Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'bxEMLePhZx',
        saved_images: {},
        width: 1000,
        height: 500,
    },
    {
        name: 'texture13.jpg',
        path: 'pxl-kjmdkwkh/texture13.jpg',
        file_size: 406361,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture13.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture13.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T10:20:44.837277Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'QwNeNuXUBK',
        saved_images: {},
        width: 1000,
        height: 641,
    },
    {
        name: 'texture17.jpg',
        path: 'pxl-kjmdkwkh/texture17.jpg',
        file_size: 121864,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture17.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture17.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T10:20:44.972750Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'vYMBmQjjZz',
        saved_images: {},
        width: 1000,
        height: 600,
    },
    {
        name: 'texture19.jpg',
        path: 'pxl-kjmdkwkh/texture19.jpg',
        file_size: 34660,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture19.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture19.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T10:20:45.618307Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'cnPcjtoDQF',
        saved_images: {},
        width: 1000,
        height: 641,
    },
    {
        name: 'texture18.jpg',
        path: 'pxl-kjmdkwkh/texture18.jpg',
        file_size: 300416,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture18.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture18.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T10:20:46.594740Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'sblqYeFiJd',
        saved_images: {},
        width: 1000,
        height: 432,
    },
    {
        name: 'texture14.jpg',
        path: 'pxl-kjmdkwkh/texture14.jpg',
        file_size: 228693,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture14.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture14.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T10:20:46.959801Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'KKEArdVBHY',
        saved_images: {},
        width: 1000,
        height: 599,
    },
    {
        name: 'texture16.jpg',
        path: 'pxl-kjmdkwkh/texture16.jpg',
        file_size: 314576,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture16.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture16.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T10:20:47.153035Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'nyzPEKyLcj',
        saved_images: {},
        width: 1000,
        height: 506,
    },
    {
        name: 'texture6.jpg',
        path: 'pxl-kjmdkwkh/texture6.jpg',
        file_size: 263396,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture6.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture6.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T10:20:48.554342Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'HXomTOIhOg',
        saved_images: {},
        width: 1000,
        height: 667,
    },
    {
        name: 'texture3.jpg',
        path: 'pxl-kjmdkwkh/texture3.jpg',
        file_size: 315224,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture3.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture3.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T10:20:51.711732Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'jwTCGIBsVS',
        saved_images: {},
        width: 1000,
        height: 667,
    },
    {
        name: 'texture5.jpg',
        path: 'pxl-kjmdkwkh/texture5.jpg',
        file_size: 1175817,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture5.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture5.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T10:20:51.468958Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'OsdJQddDdu',
        saved_images: {},
        width: 1000,
        height: 667,
    },
    {
        name: 'texture2.jpg',
        path: 'pxl-kjmdkwkh/texture2.jpg',
        file_size: 786065,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture2.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture2.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T10:20:54.500974Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'bxgdMOuNMu',
        saved_images: {},
        width: 1000,
        height: 667,
    },
    {
        name: 'Vacation1.jpg',
        path: 'pxl-kjmdkwkh/Vacation1.jpg',
        file_size: 182329,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/Vacation1.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/Vacation1.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-13T07:25:36.158033Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'zrEyCTYyVw',
        saved_images: {},
        width: 1000,
        height: 600,
    },
    {
        name: 'texture1.jpg',
        path: 'pxl-kjmdkwkh/texture1.jpg',
        file_size: 1889298,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture1.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture1.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T10:20:58.032325Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'jAIzeiAVUj',
        saved_images: {},
        width: 1000,
        height: 924,
    },
    {
        name: 'Beaches9.jpg',
        path: 'pxl-kjmdkwkh/Beaches9.jpg',
        file_size: 469476,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/Beaches9.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/Beaches9.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-13T07:25:49.063415Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'bovyPgIhhR',
        saved_images: {},
        width: 1000,
        height: 507,
    },
    {
        name: 'texture21.jpg',
        path: 'pxl-kjmdkwkh/texture21.jpg',
        file_size: 182104,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture21.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture21.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T11:37:00.584938Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'oPXyCljlQT',
        saved_images: {},
        width: 1000,
        height: 667,
    },
    {
        name: 'texture20.jpg',
        path: 'pxl-kjmdkwkh/texture20.jpg',
        file_size: 868524,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture20.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture20.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-07T11:37:01.720720Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'KfKMDWzGqt',
        saved_images: {},
        width: 1000,
        height: 1000,
    },
    {
        name: 'texture22.jpg',
        path: 'pxl-kjmdkwkh/texture22.jpg',
        file_size: 498035,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/texture22.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/texture22.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-13T07:26:06.867199Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'wxdwqqZGkz',
        saved_images: {},
        width: 1000,
        height: 600,
    },
    {
        name: 'Beaches3.jpg',
        path: 'pxl-kjmdkwkh/Beaches3.jpg',
        file_size: 667268,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/Beaches3.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/Beaches3.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-13T07:26:21.259873Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'indQpJnieD',
        saved_images: {},
        width: 1000,
        height: 466,
    },
    {
        name: 'scenery7.jpg',
        path: 'pxl-kjmdkwkh/scenery7.jpg',
        file_size: 833478,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/scenery7.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/scenery7.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-21T12:29:12.124935Z',
        client_ip: '14.98.199.186',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'MmUVUgWJNM',
        saved_images: {},
        width: 1000,
        height: 547,
    },
    {
        name: 'scenery6.jpg',
        path: 'pxl-kjmdkwkh/scenery6.jpg',
        file_size: 753902,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/scenery6.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/scenery6.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-21T12:29:28.103646Z',
        client_ip: '14.98.199.186',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'YYubGquDTk',
        saved_images: {},
        width: 1000,
        height: 563,
    },
    {
        name: 'scenery5.jpg',
        path: 'pxl-kjmdkwkh/scenery5.jpg',
        file_size: 970475,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/scenery5.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/scenery5.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-21T12:29:40.448098Z',
        client_ip: '14.98.199.186',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'zTIHNuuErH',
        saved_images: {},
        width: 1000,
        height: 626,
    },
    {
        name: 'scenery4.jpg',
        path: 'pxl-kjmdkwkh/scenery4.jpg',
        file_size: 1370813,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/scenery4.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/scenery4.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-21T12:29:53.231455Z',
        client_ip: '14.98.199.186',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'cOGjRwIVTR',
        saved_images: {},
        width: 1000,
        height: 667,
    },
    {
        name: 'scenery3.jpg',
        path: 'pxl-kjmdkwkh/scenery3.jpg',
        file_size: 984004,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/scenery3.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/scenery3.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-21T12:30:05.027839Z',
        client_ip: '14.98.199.186',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'XbAyNQxApr',
        saved_images: {},
        width: 1000,
        height: 667,
    },
    {
        name: 'scenery2.jpg',
        path: 'pxl-kjmdkwkh/scenery2.jpg',
        file_size: 788235,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/scenery2.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/scenery2.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-21T12:30:15.719256Z',
        client_ip: '14.98.199.186',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'JvzdEwfIIB',
        saved_images: {},
        width: 1280,
        height: 800,
    },
    {
        name: 'scenery1.jpg',
        path: 'pxl-kjmdkwkh/scenery1.jpg',
        file_size: 444753,
        cdn_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/scenery1.jpg',
        thumbnail_url: 'https://img.perceptpixel.com/pxl-kjmdkwkh/w_600,h_600,c_pad,b_255-255-255/scenery1.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-21T12:30:25.947400Z',
        client_ip: '14.98.199.186',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'qcISNECzYC',
        saved_images: {},
        width: 2000,
        height: 1349,
    },
];

const textureImagesDev = [
    {
        name: 'texture15.jpg',
        path: 'pxl-pytyxuab/texture15.jpg',
        file_size: 119922,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture15.jpg',
        thumbnail_url:
            'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture15.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:05.617767Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'woktBujJGs',
        saved_images: {},
        width: 1000,
        height: 667,
    },
    {
        name: 'texture16.jpg',
        path: 'pxl-pytyxuab/texture16.jpg',
        file_size: 314576,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture16.jpg',
        thumbnail_url:
            'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture16.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:08.203277Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'IbYyvpVDPg',
        saved_images: {},
        width: 1000,
        height: 506,
    },
    {
        name: 'texture17.jpg',
        path: 'pxl-pytyxuab/texture17.jpg',
        file_size: 121864,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture17.jpg',
        thumbnail_url:
            'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture17.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:08.847970Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'axHnPwwFJe',
        saved_images: {},
        width: 1000,
        height: 600,
    },
    {
        name: 'texture18.jpg',
        path: 'pxl-pytyxuab/texture18.jpg',
        file_size: 300416,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture18.jpg',
        thumbnail_url:
            'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture18.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:09.432125Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'GwjOpNXrky',
        saved_images: {},
        width: 1000,
        height: 432,
    },
    {
        name: 'texture4.jpg',
        path: 'pxl-pytyxuab/texture4.jpg',
        file_size: 273702,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture4.jpg',
        thumbnail_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture4.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:10.289569Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'GynjsrXdTJ',
        saved_images: {},
        width: 1000,
        height: 667,
    },
    {
        name: 'texture3.jpg',
        path: 'pxl-pytyxuab/texture3.jpg',
        file_size: 315224,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture3.jpg',
        thumbnail_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture3.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:10.507580Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'kmzKmUEkPP',
        saved_images: {},
        width: 1000,
        height: 667,
    },
    {
        name: 'texture1.jpg',
        path: 'pxl-pytyxuab/texture1.jpg',
        file_size: 1889298,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture1.jpg',
        thumbnail_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture1.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:12.613232Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'iTSfGApqfB',
        saved_images: {},
        width: 1000,
        height: 924,
    },
    {
        name: 'texture19.jpg',
        path: 'pxl-pytyxuab/texture19.jpg',
        file_size: 34660,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture19.jpg',
        thumbnail_url:
            'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture19.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:12.549811Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'oHIJsvVfho',
        saved_images: {},
        width: 1000,
        height: 641,
    },
    {
        name: 'texture5.jpg',
        path: 'pxl-pytyxuab/texture5.jpg',
        file_size: 1175817,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture5.jpg',
        thumbnail_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture5.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:13.559910Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'UpdrqdgDdN',
        saved_images: {},
        width: 1000,
        height: 667,
    },
    {
        name: 'texture2.jpg',
        path: 'pxl-pytyxuab/texture2.jpg',
        file_size: 786065,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture2.jpg',
        thumbnail_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture2.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:13.298710Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'HItssuGwuj',
        saved_images: {},
        width: 1000,
        height: 667,
    },
    {
        name: 'texture9.jpg',
        path: 'pxl-pytyxuab/texture9.jpg',
        file_size: 1303693,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture9.jpg',
        thumbnail_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture9.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:14.316746Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'FXRJmwgOyD',
        saved_images: {},
        width: 1000,
        height: 668,
    },
    {
        name: 'texture7.jpg',
        path: 'pxl-pytyxuab/texture7.jpg',
        file_size: 945949,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture7.jpg',
        thumbnail_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture7.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:15.035156Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'EdwMnpKKzU',
        saved_images: {},
        width: 1000,
        height: 702,
    },
    {
        name: 'texture8.jpg',
        path: 'pxl-pytyxuab/texture8.jpg',
        file_size: 892738,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture8.jpg',
        thumbnail_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture8.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:15.773850Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'IbhnQoYFoA',
        saved_images: {},
        width: 1000,
        height: 471,
    },
    {
        name: 'texture20.jpg',
        path: 'pxl-pytyxuab/texture20.jpg',
        file_size: 868524,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture20.jpg',
        thumbnail_url:
            'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture20.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:15.937153Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'UtpuxNCkIq',
        saved_images: {},
        width: 1000,
        height: 1000,
    },
    {
        name: 'texture21.jpg',
        path: 'pxl-pytyxuab/texture21.jpg',
        file_size: 182104,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture21.jpg',
        thumbnail_url:
            'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture21.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:16.078721Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'rSoxNzzfro',
        saved_images: {},
        width: 1000,
        height: 667,
    },
    {
        name: 'texture14.jpg',
        path: 'pxl-pytyxuab/texture14.jpg',
        file_size: 228693,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture14.jpg',
        thumbnail_url:
            'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture14.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:06.624371Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'GULOPNkzAX',
        saved_images: {},
        width: 1000,
        height: 599,
    },
    {
        name: 'texture12.jpg',
        path: 'pxl-pytyxuab/texture12.jpg',
        file_size: 289278,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture12.jpg',
        thumbnail_url:
            'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture12.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:06.686739Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'DOdhFoGDEb',
        saved_images: {},
        width: 1000,
        height: 500,
    },
    {
        name: 'texture11.jpg',
        path: 'pxl-pytyxuab/texture11.jpg',
        file_size: 498035,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture11.jpg',
        thumbnail_url:
            'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture11.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:07.095037Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'wbNeosuisa',
        saved_images: {},
        width: 1000,
        height: 600,
    },
    {
        name: 'texture13.jpg',
        path: 'pxl-pytyxuab/texture13.jpg',
        file_size: 406361,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture13.jpg',
        thumbnail_url:
            'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture13.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:07.096777Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'pwSbvLPgky',
        saved_images: {},
        width: 1000,
        height: 641,
    },
    {
        name: 'texture10.jpg',
        path: 'pxl-pytyxuab/texture10.jpg',
        file_size: 932039,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture10.jpg',
        thumbnail_url:
            'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture10.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:08.187584Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'olvrVDeuBV',
        saved_images: {},
        width: 1000,
        height: 563,
    },
    {
        name: 'texture6.jpg',
        path: 'pxl-pytyxuab/texture6.jpg',
        file_size: 263396,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture6.jpg',
        thumbnail_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture6.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-08T14:59:13.014269Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'lPHdHKhCbM',
        saved_images: {},
        width: 1000,
        height: 667,
    },
    {
        name: 'Beaches2.jpg',
        path: 'pxl-pytyxuab/Beaches2.jpg',
        file_size: 707773,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/Beaches2.jpg',
        thumbnail_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/Beaches2.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-12T11:28:26.675141Z',
        client_ip: '14.98.199.186',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'uxZiDXccqh',
        saved_images: {},
        width: 1000,
        height: 667,
    },
    {
        name: 'Beaches3.jpg',
        path: 'pxl-pytyxuab/Beaches3.jpg',
        file_size: 667268,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/Beaches3.jpg',
        thumbnail_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/Beaches3.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-12T11:28:28.758075Z',
        client_ip: '14.98.199.186',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'uLlmexpRGM',
        saved_images: {},
        width: 1000,
        height: 466,
    },
    {
        name: 'texture22.jpg',
        path: 'pxl-pytyxuab/texture22.jpg',
        file_size: 498035,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/texture22.jpg',
        thumbnail_url:
            'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/texture22.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-12T11:22:47.257208Z',
        client_ip: '14.98.199.186',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'IzhOgUitqy',
        saved_images: {},
        width: 1000,
        height: 600,
    },
    {
        name: 'Vacation1.jpg',
        path: 'pxl-pytyxuab/Vacation1.jpg',
        file_size: 182329,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/Vacation1.jpg',
        thumbnail_url:
            'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/Vacation1.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-13T06:23:07.098121Z',
        client_ip: '49.207.193.20',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'nujHNUAfiM',
        saved_images: {},
        width: 1000,
        height: 600,
    },
    {
        name: 'Beaches1.jpg',
        path: 'pxl-pytyxuab/Beaches1.jpg',
        file_size: 469476,
        cdn_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/Beaches1.jpg',
        thumbnail_url: 'https://img.staging.perceptpixel.com/pxl-pytyxuab/w_600,h_600,c_pad,b_255-255-255/Beaches1.jpg',
        type: 'jpeg',
        uploaded_by: 'perceptpixel@gmail.com',
        updated_at: '2024-02-12T11:25:51.640098Z',
        client_ip: '14.98.199.186',
        user_agent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36',
        uid: 'TBnfqhNQBd',
        saved_images: {},
        width: 1000,
        height: 507,
    },
];

export const GetTextureFiles = () => {
    if (window.location.origin.includes('localhost') || window.location.origin.includes('staging')) {
        return textureImagesDev;
    } else {
        return textureImagesProd;
    }
};
